import { nike } from '@nike/nike-design-tokens';
import styled from '@emotion/styled';
import { TextStyled } from '@nike/nike-design-system-components';

const {
  podiumCdsColorTextPrimary,
  podiumCdsColorTextPrimaryInverse,
  podiumCdsFontSizeXs,
  podiumCdsColorGrey300
} = nike;

const stepLabelCSS = styled(TextStyled);
export const StepLabelCss = stepLabelCSS`
  padding-left: 5px;
`;

const stepIconCSS = styled.span;
export const StepIconCss = stepIconCSS`
  height: 25px;
  width: 25px;
  background-color: ${({ completedOrActive }) =>
    completedOrActive ? `${podiumCdsColorTextPrimary}` : `${podiumCdsColorGrey300}`};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${podiumCdsFontSizeXs};
  color: ${podiumCdsColorTextPrimaryInverse};
`;
